module.exports = __webpack_public_path__ + "media/images/discord-black-2d0d3d1ac5ef019e2b303c3258ff352e.svg";